import { FC, useState } from "react"

import { IPage } from "../../../models"
import { MUIIcon } from "../../../../../widgets"
import Modal from "react-bootstrap/esm/Modal"
import { PageSettings } from "./PageSettings"

interface IPageSettingsDialogProps {
    show: boolean
    hideModal: () => void
    page: IPage
    onChange: (page: IPage) => void
}

export const PageSettingsDialog: FC<IPageSettingsDialogProps> = ({
    show, hideModal, page, onChange
}) => {
    const [localPage, setLocalPage] = useState<IPage>(page)

    const cancelChanges = () => {
        setLocalPage(page)
        hideModal()
    }

    const pushChanges = () => {
        onChange(localPage)
        hideModal()
    }

    return <>
        <Modal show={show} onHide={hideModal} dialogClassName="min-w-75 p-20">
            <Modal.Header closeButton className="bg-gray-300 border-0 py-3">
                <h4 className="my-0">Page Settings</h4>
            </Modal.Header>
            <Modal.Body>
                <PageSettings page={localPage} onChange={setLocalPage} />
            </Modal.Body>
            <Modal.Footer className="border-0 py-5">
                <button type="button"
                    onClick={pushChanges}
                    className="btn btn-sm btn-primary py-2">
                    <MUIIcon iconName={"CheckOutlined"} className="me-1" />
                    OK
                </button>
                <button type="button"
                    onClick={cancelChanges}
                    className="btn btn-sm btn-secondary py-2">
                    <MUIIcon iconName={"CancelOutlined"} className="me-1" />
                    Cancel
                </button>
            </Modal.Footer>

        </Modal>
    </>
}
